export default __webpack_public_path__ + "static/media/egg.9178bb7d.png";